import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ImagineSection } from './components/ImagineSection';
import { SolutionSection } from './components/SolutionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyPixel } from './components/UtmifyPixel';
export function App() {
  return <div className="min-h-screen bg-pilates-cream font-sans selection:bg-pilates-sage/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UtmifyPixel data-id="element-2" />
      <Hero data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <ImagineSection data-id="element-5" />
      <SolutionSection data-id="element-6" />
      <BeforeAfterSection data-id="element-7" />
      <BonusesSection data-id="element-8" />
      <BenefitsSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
      <PurchaseNotification data-id="element-16" />
    </div>;
}